module.exports = __webpack_public_path__ + "static/img/Tech_01.d86a36df.png";